// analyticsClient.ts
import { posthog } from 'posthog-js';
posthog.init(process.env.EXPO_PUBLIC_POST_HOG_API_KEY!, {
    api_host: process.env.EXPO_PUBLIC_POST_HOG_HOST!,
    autocapture: false,
    capture_pageview: false,
    ip: false,
    capture_heatmaps: true,
    session_recording: {
        recordCrossOriginIframes: false,
        maskAllInputs: true,
        maskCapturedNetworkRequestFn: (request) => {
            request.requestBody = null;
            request.responseBody = null;
            return request;
        },
    },
});
export const analyticsClient = posthog;